module.exports = __webpack_public_path__ + "static/media/icon_payment_orange.ac4900ee.svg";